export default __webpack_public_path__ + "static/media/link-solid.7b689dbd.svg";